'use strict';
import { InjectableClass } from '@fino/lib-injection';

class FaqService extends InjectableClass {
  constructor(uiModalDeclarationService) {
    'ngInject';
    super({
      uiModalDeclarationService
    });
  }

  openModal() {
    this.modal = this.uiModalDeclarationService.$uibModal.open({
      component: 'faqComponent',
      size: 'lg'
    });
  }

  closeModal() {
    if(this.modal) {
      this.modal.close();
    }
  }
}

export default FaqService;
